// src/pages/reportUsage/nextBtnClickHandlerUtil.js
export default function nextBtnClickHandlerUtil({
    reportPaymentScreenName,
    myCaseResourceType,
    showReportPayment,
    reportPaymentGridData,
    myCaseRefId,
    getRPValidateItemsArr,
    dispatch,
    validateProductDetails,
    usageDetails,
    validateUnidPlanFeeItems,
    replenRPGridData,
    setIsProcedureBtnClicked,
    setNextBtnClicked,
    setShowCancelPopUp,
    setReportPaymentScreenName,
    getModifiedButtonVisibilities,
    footerButtonStatuses,
    next,
    submit,
    setFooterButtonStatuses,
}) {
    if (reportPaymentScreenName === 'Report Payment') {
        if (
            myCaseResourceType === 'reportPayment' &&
            showReportPayment &&
            reportPaymentGridData.length > 0 &&
            myCaseRefId
        ) {
            const validateItemsArr = getRPValidateItemsArr(reportPaymentGridData);
            const validateItemsObj = {
                myCaseRef: myCaseRefId,
                products: validateItemsArr,
            };
            if (
                myCaseResourceType === 'reportPayment' &&
                showReportPayment &&
                reportPaymentGridData.length > 0 &&
                myCaseRefId &&
                !usageDetails.unidId
            ) {
                const validateItemsArr = getRPValidateItemsArr(reportPaymentGridData);
                const validateItemsObj = {
                    myCaseRef: myCaseRefId,
                    products: validateItemsArr,
                };
                dispatch(validateProductDetails(validateItemsObj, true));
            } else {
                if (usageDetails.unidId) {
                    dispatch(
                        validateUnidPlanFeeItems(validateItemsObj, true)
                    );
                }
            }
        }
    } else if (reportPaymentScreenName === 'Replenish') {
        if (
            replenRPGridData.some(
                (data) =>
                    data.isSelected &&
                    !data.shippingDetails &&
                    !data.accountOwned
            )
        ) {
            setIsProcedureBtnClicked(true);
            setNextBtnClicked(true);
            setShowCancelPopUp(true);
        } else {
            dispatch(setReportPaymentScreenName('Review'));
            const modifiedButtonStatuses = getModifiedButtonVisibilities(
                myCaseResourceType,
                footerButtonStatuses,
                next,
                submit
            );
            setFooterButtonStatuses(modifiedButtonStatuses);
        }
    }
}